import { Action, createReducer, on } from "@ngrx/store";
import * as paymentsActions from "./payments.actions";
import { PaymentDto } from "../interfaces/payment_dto";
import { PaymentBalance } from "../interfaces/payment_balance";

export const paymentFeatureKey = "payments";

export interface State {
  [paymentFeatureKey]: PaymentsState;
  arePaymentsLoaded: boolean;
  paymentFilter: string;
  isLoading: boolean;
}

export interface PaymentsState {
  entities: { [id: string]: PaymentDto };
  ids: number[];
  selectedPayment: number | null;
  arePaymentsLoaded: boolean;
  paymentFilter: string;
  openPayments: PaymentBalance[];
  isLoading: boolean;
}

export const initialState: PaymentsState = {
  entities: {},
  ids: [],
  selectedPayment: null,
  arePaymentsLoaded: false,
  paymentFilter: "Alle",
  openPayments: [],
  isLoading: false
};

const paymentsReducer = createReducer(
  initialState,
  on(paymentsActions.loadPayments, (state) => ({
    ...state,
    arePaymentsLoaded: false,
  })),
  on(paymentsActions.loadPaymentsSuccess, (state, { payments }) => ({
    ...state,
    entities: payments.reduce(
      (acc, payment) => ({ ...acc, [payment.payment_id]: payment }),
      {}
    ),
    ids: payments.map((payment) => payment.payment_id),
    arePaymentsLoaded: true,
  })),
  on(paymentsActions.selectPayment, (state, { payment }) => ({
    ...state,
    selectedPayment: payment.payment_id,
  })),
  on(paymentsActions.addPayments, (state, { payments }) => ({
    ...state,
    entities: {
      ...state.entities,
      ...payments.reduce(
        (acc, payment) => ({ ...acc, [payment.payment_id]: payment }),
        {}
      ),
    },
    ids: [...state.ids, ...payments.map((payment) => payment.payment_id)],
  })),
  on(paymentsActions.addPayment, (state, { payment }) => ({
    ...state,
    isLoading: true,
  })),
  on(paymentsActions.addPaymentSuccess, (state, { payment }) => ({
    ...state,
    entities: { ...state.entities, [payment.payment_id]: payment },
    ids: [...state.ids, payment.payment_id],
    selectedPayment: payment.payment_id,
    isLoading: false,
  })),
  on(paymentsActions.deletePaymentSuccess, (state, { payment }) => {
    const updatedEntities = { ...state.entities };
    delete updatedEntities[payment.payment_id];
    const updatedIds = state.ids.filter(id => id !== payment.payment_id);
    return {
      ...state,
      entities: updatedEntities,
      ids: updatedIds,
      selectedPayment: null,
      isLoading: false,
    };
  }),
  on(paymentsActions.createAndSendPaymentMail, (state, { sendRequest, paymentAddRequest, file }) => ({
    ...state,
    isLoading: true,
  })),
  on(paymentsActions.setPaymentFilter, (state, { paymentFilter }) => ({
    ...state,
    paymentFilter,
  })),
  on(paymentsActions.getPaymentBalance, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(paymentsActions.getPaymentBalanceSuccess, (state, { openPayments }) => ({
    ...state,
    openPayments,
    isLoading: false,
  })),
  on(paymentsActions.clearPaymentBalance, (state) => ({
    ...state,
    openPayments: [],
  })),
  on(paymentsActions.upsertPayments, (state, { payments }) => {
    const updatedEntities = { ...state.entities };
    const updatedIds: number[] = [];

    payments?.forEach((payment) => {
      if (payment?.payment_id !== undefined) {
        updatedEntities[payment.payment_id] = payment;
        updatedIds.push(payment.payment_id);
      }
    });
    return {
      ...state,
      entities: updatedEntities,
      ids: Array.from(new Set([...state.ids, ...updatedIds])),
      arePaymentsLoaded: true,
    };
  })
);

export function paymentReducer(state: any, action: Action) {
  return paymentsReducer(state, action);
}
